module.exports = __webpack_public_path__ + "img/Full-Flutterwave.907752da.png";